<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      <router-link class="navbar-brand" to="/">
        AutoEdge 24
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <router-link class="nav-link" to="/shop">
          <div class="logo-container">
            <span class="mdi mdi-cart-outline"></span>
          </div>
          <p class="d-lg-none d-xl-none">Shop</p>
        </router-link>
      </li>
      <drop-down
              tag="li"
              title="Infos"
              icon="mdi mdi-text"
              class="nav-item"
      >
        <nav-link to="/legal">
          <span class="mdi mdi-file-document-outline"></span> Impressum
        </nav-link>
        <nav-link to="/terms">
          <span class="mdi mdi-gavel"></span> AGBs
        </nav-link>
        <nav-link to="/privacy">
          <span class="mdi mdi-account-eye-outline"></span> Datenschutzerklärung
        </nav-link>
        <nav-link to="/accessibility">
          <span class="mdi mdi-wheelchair"></span> Barrierefreiheit
        </nav-link>
      </drop-down>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Folgen Sie uns auf Instagram"
          data-placement="bottom"
          href="https://www.instagram.com/autoedge24"
          target="_blank"
        >
          <div class="logo-container">
            <span class="mdi mdi-instagram"></span>
          </div>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Kontaktieren Sie uns per Whatapp"
          data-placement="bottom"
          href="https://wa.me/4917655980480"
          target="_blank"
        >
          <div class="logo-container">
            <span class="mdi mdi-whatsapp"></span>
          </div>
          <p class="d-lg-none d-xl-none">Whatapp</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Folgen Sie uns auf Tiktok"
          data-placement="bottom"
          href="https://www.tiktok.com/@autoedge.24"
          target="_blank"
        >
          <div class="logo-container">
            <img class="logo-img" src="img/logos/TikTok_logo_transparent.png" alt="Tiktok Logo" />
          </div>
          <p class="d-lg-none d-xl-none">TikTok</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavLink,
    [Popover.name]: Popover
  },
  methods: {
    homeClicked(popover) {
      popover.doClose();
      console.log("Home clicked, popover closed.", popover);
    }
  }
};
</script>

<style scoped>
.container {
  flex-direction: row;
}
.logo-container {
  height: 22px !important;
  width: 22px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px !important;

  .mdi {
    height: 100%;
    width: 100%;

    font-size: 20px;
    line-height: 20px;
  }
}
.logo-img {
  height: 100%;
  width: 100%;
}
.nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
</style>
